import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en/common.json';
import el from '../locales/el/common.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { common: en },
    el: { common: el },
  },
  fallbackLng: 'en',
  debug: false,
  interpolation: { escapeValue: false },
});

// Keep <html lang> in sync with the active language for a11y and SEO.
const syncLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng?.split('-')[0] || 'en';
  }
};
syncLang(i18n.resolvedLanguage || 'en');
i18n.on('languageChanged', syncLang);

export default i18n;
